import { LoadingButton } from '@mui/lab'
import React from 'react'
import { useToggle } from 'react-use'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export const JiraOAuthButton: React.FC<{
  onChange?: () => void
}> = ({ onChange }) => {
  const { currentTeamId } = useAuth()
  const [jiraWindow, setJiraWindow] = React.useState(null)
  const [isLoading, setLoading] = useToggle(false)
  const [isIntervalAlreadyStarted, setIsIntervalAlreadyStarted] =
    useToggle(false)

  React.useEffect(() => {
    if (jiraWindow) {
      if (!isIntervalAlreadyStarted) {
        const timer = setInterval(() => {
          if (jiraWindow.closed) {
            setJiraWindow(null)
            clearInterval(timer)
            const { message } = jiraWindow
            if (message) {
              toast({
                type: 'info',
                text: message
              })
              onChange && onChange()
            }
          }
        }, 500)
        setIsIntervalAlreadyStarted(true)
      }
    }
  }, [
    jiraWindow,
    onChange,
    isIntervalAlreadyStarted,
    setIsIntervalAlreadyStarted
  ])

  return (
    <LoadingButton
      data-testid="jira-integration-button"
      disabled={Boolean(jiraWindow) || isLoading}
      loading={Boolean(jiraWindow) || isLoading}
      variant="contained"
      onClick={async () => {
        setLoading(true)

        try {
          const resp = await agent.get(
            `/oauth/integration-login?teamId=${currentTeamId}&type=JIRA`,
            {
              withCredentials: true
            }
          )
          resp.data.location &&
            setJiraWindow(window.open(resp.data.location, 'Jira'))
        } catch (err) {
          toast({
            type: 'error',
            text: messageFromResponseError(
              err,
              'There was an issue while logging into Jira'
            )
          })
        } finally {
          setLoading(false)
        }
      }}
    >
      Connect
    </LoadingButton>
  )
}

export default JiraOAuthButton
